import { HttpClient } from '@angular/common/http';
import { MissingTranslationHandler, TranslateLoader } from '@ngx-translate/core';
import { CustomMissingTranslationHandler, TranslationHttpLoader } from 'src/core-lib/misselaineous/missing-translation-handler';



// tslint:disable: max-line-length

export const config = {

    svgDef: {},
    translate: {
        loader: {
            provide: TranslateLoader,
            useFactory: (http) => TranslationHttpLoader(http),
            deps: [HttpClient]
        },
        missingTranslationHandler: {
            provide: MissingTranslationHandler,
            useClass: CustomMissingTranslationHandler
        },
        defaultLanguage: 'da-dk',
        useDefaultLang: true
    },

};

